// Maker Embed Script
(function() {
    // Create container if not exists
    function createContainer() {
        const existing = document.getElementById('cmciwvv1c009khs5rmi45dmla-root');
        if (existing) return existing;

        const container = document.createElement('div');
        container.id = 'cmciwvv1c009khs5rmi45dmla-root';
        container.className = 'cmciwvv1c009khs5rmi45dmla-app makerai-app';

        const currentScript = document.currentScript;
        const targetId = currentScript && currentScript.getAttribute('data-target-id');
        if (targetId) {
            const target = document.getElementById(targetId);
            if (target) {
                target.appendChild(container);
                return container;
            }
            console.warn('[maker-embed] data-target-id "' + targetId + '" not found in DOM, falling back to default placement.');
        }

        if (currentScript && currentScript.parentNode && currentScript.parentNode !== document.head) {
            currentScript.parentNode.insertBefore(container, currentScript);
        } else {
            document.body.appendChild(container);
        }
        return container;
    }

    function addMadeWithMakerLink(container) {
     return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = 'https://ai.maker.co';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.position = 'sticky';
        link.style.bottom = '8px';
        link.style.right = '8px';
        link.style.left = '8px';
        link.style.textDecoration = 'none';
        link.style.zIndex = '9999';
        link.style.display = 'block';
        link.style.height = '24px';
        link.style.width = 'fit-content';
        link.style.lineHeight = '24px';
        link.style.padding = '0 8px';
        link.style.borderRadius = '6px';
        link.style.backgroundColor = 'rgba(0, 0, 0, 0.60)';
        link.style.backdropFilter = 'blur(2px)';
        link.style.color = '#FFF';
        link.style.fontFamily = 'sans-serif';
        link.style.fontSize = '12px';
        link.style.fontWeight = '500';
        link.textContent = 'Made with maker';
        container.appendChild(link);
        resolve();
      });
    }

    // Load CSS file
    function loadCSS(href) {
        return new Promise((resolve, reject) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.onload = resolve;
            link.onerror = resolve;
            document.head.appendChild(link);
        });
    }
    // Add custom style to head
    function addCustomStyle(css) {
        return new Promise((resolve, reject) => {
            const style = document.createElement('style');
            style.type = 'text/css';
            style.textContent = css;
            document.head.appendChild(style);
        });
    }

    // Load script and wait for it to be ready
    function loadScript(src, external = false, is_async = false, attrs = {}) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'module';
            script.src = src;
            Object.entries(attrs).forEach(function(entry) {
              script.setAttribute(entry[0], entry[1]);
            });
            script.onload = () => {
                // Wait a small amount of time to ensure the script has executed
                setTimeout(resolve, 100);
            };
            script.onerror = reject;
            if (external) {
              script.type = 'text/javascript';
              document.head.appendChild(script);
            }else {
              document.body.appendChild(script);
            }
            if (is_async) {
              script.async = true;
            }
        });
    }

    function loadInlineScripts(type, scriptContent, tagName) {
      return new Promise((resolve, reject) => {
        try {
          const script = document.createElement(tagName);
          if (tagName == 'script') {
              script.type = type;
          }
          script.textContent = scriptContent;
          document.body.appendChild(script);
          // inline scripts execute immediately upon append; resolve on next tick
          setTimeout(resolve, 0);
        } catch (e) {
          reject(e);
        }
      });
    }

    // Initialize
    async function init() {
        // Get base URL from current script
        const scriptElement = document.currentScript;
        const baseUrl = scriptElement.src.split('/embed.js')[0];

        try {           
            // Create container
            const container = createContainer();
           
            // Load styles
            await Promise.all([
                loadCSS(`${baseUrl}/assets/main.css`)
            ]);

            // For AB experiment: load posthog script first to ensure any tracking in inline scripts works
            await loadInlineScripts("text/javascript", `
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Ir Sr init jr $r Ci qr Hr Dr capture calculateEventProperties Wr register register_once register_for_session unregister unregister_for_session Qr getFeatureFlag getFeatureFlagPayload getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync tn identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty Jr Yr createPersonProfile setInternalOrTestUser Kr Pr nn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing zr debug ki Xr getPageViewId captureTraceFeedback captureTraceMetric Mr".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('phc_qbDTSuJCBxyX8CACLOEhPNZBvJVcELuLXGG6J2ibUmK', {
        api_host: 'https://athena.maker.co',
        ui_host: 'https://us.posthog.com',
        defaults: '2026-01-30',
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
        name: 'ph_devi_cmciwvv1c009khs5rmi45dmla',
        autocapture: {
          css_selector_allowlist: [
            '[data-tracking-id]'
          ]
        },
        loaded: function(posthog) {
          posthog.register({
            mkr_product: 'devi',
            mkr_project_id: 'cmciwvv1c009khs5rmi45dmla',
            mkr_org_id: 'user_2ZAtAYc1MFcL5x3zo53g47MXUVS',
            mkr_organization_name: 'unknown',
            mkr_version: 1777378237562
          });
          
  var _instanceName = 'ph_devi_cmciwvv1c009khs5rmi45dmla';
  window.__mkr_ph = window.__mkr_ph || {};
  window.__mkr_ph[_instanceName] = { distinctId: posthog.get_distinct_id(), buckets: {} };
  document.dispatchEvent(new CustomEvent('mkr:ph:ready', { detail: { instanceName: _instanceName, distinctId: window.__mkr_ph[_instanceName].distinctId } }));

        },
    });
  `, "script");
            
            // Load the main script and wait for it to be ready
            await loadScript(`${baseUrl}/assets/main.js`, false, true);

            // Add the Made with Maker link
            
            // Load any external scripts specified in the index.html
            
            // Load inline scripts from index.html
            
            // Now that both container and script are ready, trigger DOMContentLoaded
            // This ensures main.jsx's DOMContentLoaded handler will find the container
            const domContentLoadedEvent = new Event('DOMContentLoaded');
            document.dispatchEvent(domContentLoadedEvent);

        } catch (error) {
            console.error('Failed to load devi widget:', error);
        }
    }

    // Run initialization
    init();
})();